import { create } from 'zustand';

const useAuthStore = create((set) => ({
  token: localStorage.getItem('mbegi_token') || null,
  user: JSON.parse(localStorage.getItem('mbegi_user') || 'null'),

  login: (token, user) => {
    localStorage.setItem('mbegi_token', token);
    localStorage.setItem('mbegi_user', JSON.stringify(user));
    set({ token, user });
  },

  logout: () => {
    localStorage.removeItem('mbegi_token');
    localStorage.removeItem('mbegi_user');
    set({ token: null, user: null });
  },

  isAuthenticated: () => !!localStorage.getItem('mbegi_token'),
}));

export default useAuthStore;
